import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vex-error-upgrade-modal',
  templateUrl: './error-upgrade-modal.component.html',
  styleUrls: ['./error-upgrade-modal.component.scss']
})
export class ErrorUpgradeModalComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
